import React from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { toggleTheme } from '../../store/slices';
import { FiMoon, FiSun } from 'react-icons/fi';
import Icon from '../Icon';

export default function ThemeToggle() {
    const dispatch = useAppDispatch();
    const mode = useAppSelector((s) => s.theme.mode);
    return (
        <button
            type="button"
            onClick={() => dispatch(toggleTheme())}
            aria-label="Toggle theme"
            className={
                [
                    'pointer-events-auto inline-flex h-11 w-11 items-center justify-center rounded-full shadow-lg transition-transform active:scale-95',
                    'focus:outline-none focus:ring-2 focus:ring-white/60 focus:ring-offset-2 focus:ring-offset-transparent',
                    mode === 'dark'
                        ? 'bg-gradient-to-br from-indigo-500 to-blue-600 text-white'
                        : 'bg-gradient-to-br from-amber-400 to-yellow-500 text-white'
                ].join(' ')
            }
        >
            {mode === 'dark' ? <Icon icon={FiMoon} /> : <Icon icon={FiSun} />}
        </button>
    );
}
